import React from 'react';

import Logo from '../UI/Logo';
import NavigationItems from './NavigationItems';
import HamburgerIcon from './HamburgerIcon';

const ToolBar = props => {
    return (
        <header>
            <div className="main-header">
                <HamburgerIcon clicked={props.SideDrawerOpened}/>
                <div className="main-header__logo">
                    <Logo />
                </div>
                <nav className="main-navigation">
                    <NavigationItems />
                </nav>
            </div>
        </header>
    );
}

export default ToolBar;